import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from '../../../api.service';
// import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import Swal from 'sweetalert2';
import { Router, RouterModule } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';




@Component({
  selector: 'app-reportingtoallocation',
  templateUrl: './reportingtoallocation.component.html',
  styleUrls: ['./reportingtoallocation.component.css']
})
export class ReportingtoallocationComponent implements OnInit {
  @ViewChild('agGrid',{static:false}) agGrid: AgGridAngular;

  displayPosition: boolean;
  rows = [];
  searchQR: any;
  value1: any;
  rangeValues: number[] = [0,100];

  Finals_excel : any;

  Bank_list_gets : any;
  product_list_gets  : any;
  portfolio_list_gets  : any;
  Bank_list : any;
  portfolio_list : any;
  booleans : any;
  product_list : any;
  User_details1 : any;



  loading: Boolean = false;


  Excel_Datas :  any;
  saved_Fields : any;




  user_list_details : any;
  Company_details : any;
  Designation_details2 : any;
  report_to : any;
  report_to_id : any;
  company_name : any;
  report_to_design : any;

  Designation_details1 : any;
  MyuploadList = [];
  tempDefs = [];
  columnDefs = [];
  dataLoaded: boolean;
  data = [];
  login_Details: any;
  bankName: any;
  bankame: any;
  portfolio: any;
  product: any;


  timeLeft: number = 60;
  interval;
  bucket_details : any;

  bucket_detail : any;

  final_data : any;


  portfolio_bucket_id : any;
  transferData: any[];
  total_out_standing: number = 0;

  userFilter: any = { customer_id: '',acc_no:'',passport_no:'',total_out_standing:''};
  constructor(
    private router: Router,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    private _api: ApiService,
    // private router: Router
  ) {

   }



  ngOnInit(): void {
    this.bucket_details = new Date().getTime();
    window.scrollTo(0, 0);
    this.portfolio_bucket_id = this.getFromLocal("portfolio_bucket_id");




        // this._api.fetch_data_using_allocated_ist_report(a).subscribe(


    let a  = {
      assigned_to : this.getFromLocal("Report_to_id"),
    }
    this._api.fetch_data_using_allocated_ist_report(a).subscribe(
      (response: any) => {
        this.saved_Fields = response.Data;
        this.saved_Fields.forEach((item, i) => {
          item.select_status = false;
          this.total_out_standing = this.total_out_standing + Number(item.total_out_standing);
        });
        this.loading = true;
      }
    );



  }


  saveInLocal(key, val): void {
    this.storage.set(key, val);
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }

  toggleEditable(status: any, index: any){
   this.saved_Fields[index].select_status = status;
  }

  getFin(event){
      this.userFilter.customer_id = event.target.value;
  }
  getPass(event){
    this.userFilter.passport_no = event.target.value;
  }
  getAcc(event){
    this.userFilter.acc_no = event.target.value;
  }
  getAgg(event){
    this.userFilter.agreement_id = event.target.value;
  }
  getCif(event){
    this.userFilter.cif = event.target.value;
  }
  getOTS(event){
    this.userFilter.total_out_standing = event.target.value;
  }

  submit_allocation(){
     this.final_data = [];
     for(let a  = 0 ; a < this.saved_Fields.length ; a ++){
         if(this.saved_Fields[a].select_status == true){
          this.final_data.push(this.saved_Fields[a]);
         }
         if(a == this.saved_Fields.length - 1){
         if(this.final_data.length == 0){
            alert("Please Select the customers");
          }else{
             this.start_allocation()
          }

         }
     }
  }


  start_allocation(){

    if(this.report_to_id == undefined){
      alert('Please Select the user');
    } else {

      this.bucket_detail = this.getFromLocal("bucket_detail");
     for(let a = 0 ; a < this.final_data.length; a ++){
      let c = {
        bucket_id : this.bucket_detail.bucket_id,
        bank_name : this.bucket_detail.bank_name,
        client_id : this.bucket_detail.client_id,
        product_id : this.bucket_detail.product_id,
        customer_id : this.final_data[a].customer_id,
        assigned_by : '1',
        assigned_to : this.report_to_id,
        date_of_assign : ""+new Date(),
        touch_status : 'Not Touched',


  acc_no : this.final_data[a].acc_no,
  agreement_id : this.final_data[a].acc_no,
  allocated_to : this.final_data[a].acc_no,
  allocations_status : this.final_data[a].acc_no,
  cif : this.final_data[a].acc_no,
  customer_details : this.final_data[a].acc_no,
  date_of_allocations : this.final_data[a].acc_no,
  finterstal_id : this.final_data[a].acc_no,
  passport_no : this.final_data[a].acc_no,
  total_out_standing :this.final_data[a].acc_no,

  nationality : this.final_data[a].nationality,
  cycle : this.final_data[a].cycle,
  flow_status : this.final_data[a].flow_status,

  product_name : this.final_data[a].product_name,
  bank_allocation : this.final_data[a].bank_allocation,
  bucket : this.final_data[a].bucket,






      }
        this._api.allocation_details_adds(c).subscribe(
          (response: any) => {
            let d = {
              user_id : "1",
              bucket_id : this.bucket_detail.bucket_id,
              customer_id : this.final_data[a].customer_id,
              assigned_to : this.report_to_id
            }
            this._api.excel_details_update(d).subscribe(
              (response: any) => {
              }
            );
          }
        );
     }
    }
  }


  showPositionDialog() {
    this.displayPosition = true;
  }


  // getCustomer(page,data){
  //   console.log(data.customer_details);
  //  var test_text = JSON.parse(data.customer_details);
  //   var convDatav = test_text;
  //   console.log(convDatav['length']);
  //   if (convDatav['length'] == 0) {
  //     var jsonObject = convDatav[0];
  //     var keyCount  = Object.keys(jsonObject).length;
  //     console.log(keyCount);
  //   } else {
  //     var jsonObject = convDatav;
  //     var keyCount  = Object.keys(jsonObject).length;
  //   }
    
    
  //   this.router.navigateByUrl(page);
  //   let dataList = [];
  //   for (let i = 0; i < convDatav.length; i++) {
  //         for (let i = 0; i < keyCount; i++) {
  //           var key = Object.keys(jsonObject)[i];
  //           var value = jsonObject[key];
  //           dataList.push({column:key,row:value});
  //         }
  //       }

  //     this.storage.set("_storedRecord",{dataList,"keyvalue":data});

  // }
  getCustomer(page,data){
    let d = {
      passport_no :  data.passport_no,
      acc_no :  data.acc_no,
      bank_id : data.bank_id,
      portfolio_id :  data.porfolio_id,
      product_id : data.product_id, 
      finterstal_id: data.finterstal_id
    }
    this._api.fetch_customer_detail(d).subscribe(
      (response: any) => {
      

        if (response.Data[0].customer_details[0].insert_id != undefined) {
          var test_text = response.Data[0].customer_details;
          var convDatav = test_text;
          // console.log(convDatav['length']);
          var jsonObject = convDatav[0];
          var keyCount  = Object.keys(jsonObject).length;
          // console.log(keyCount);
          let dataList = [];
          for (let i = 0; i < convDatav.length; i++) {
                for (let i = 0; i < keyCount; i++) {
                  var key = Object.keys(jsonObject)[i];
                  if (key == "assigned_by" || key == "Acc_no" || key == "Account_No"  || key == "Bank_ID"  ||  key == "Portfolio_ID"  || key == "") {
                    
                  } else {
                    var value = jsonObject[key];
                    dataList.push({column:key,row:value});
                  }
                }
              }
            this.storage.set("_storedRecord",{dataList,"keyvalue":data});
            this.router.navigateByUrl(page);
        } else {
          var test_text = JSON.parse(response.Data[0].customer_details[0]);
          var convDatav = test_text;
          // console.log(convDatav['length']);
          var jsonObject = convDatav[0];
          var keyCount  = Object.keys(jsonObject).length;
          // console.log(keyCount);
          let dataList = [];
          for (let i = 0; i < convDatav.length; i++) {
                for (let i = 0; i < keyCount; i++) {
                  var key = Object.keys(jsonObject)[i];
                  if (key == "assigned_by" || key == "Acc_no" || key == "Account_No"  || key == "Bank_ID"  ||  key == "Portfolio_ID"  || key == "") {
                    
                  } else {
                    var value = jsonObject[key];
                    dataList.push({column:key,row:value});
                  }
                }
              }
            this.storage.set("_storedRecord",{dataList,"keyvalue":data});
            this.router.navigateByUrl(page);
        }

    
      }
    );
  }



}
